<div [class.blocked]="blockUI">
  @if (showNavProgress) {
  <div class="spur-nav-progress" role="progressbar" aria-label="Loading page"></div>
  }
  <vebo-header *ngIf="currenturl != 'ticket-map-web-view'"></vebo-header>
  @defer (on idle) {
  <vebo-modals></vebo-modals>
  }
  <app-spur-toaster></app-spur-toaster>

  <div class="body-content-wrapper" id="body-content-wrapper">
    @if (showExpNavLoader) {
    <div class="spur-page-loader spur-page-loader--route" role="status" aria-live="polite" aria-busy="true">
      <div class="spur-page-loader__inner">
        <div class="spur-page-loader__visual" aria-hidden="true">
          <span class="spur-page-loader__orbit"></span>
          <span class="spur-page-loader__mark"></span>
        </div>
        <p class="spur-page-loader__brand">Spur Experiences</p>
        @for (line of [expNavLoaderLine]; track expNavLoaderLineIndex) {
        <p class="spur-page-loader__line">{{ line }}</p>
        }
      </div>
    </div>
    }
    <router-outlet></router-outlet>
  </div>

  <!-- cookies — Spur consent card (handlers unchanged) -->
  <div class="cookies_view spur-consent" *ngIf="displayAcceptCookies == true && !isCookies"
    role="dialog" aria-modal="false" aria-labelledby="spur-consent-title" aria-describedby="spur-consent-desc">
    <div class="spur-consent__card">
      <span class="spur-consent__watermark" aria-hidden="true">SPUR</span>
      <div class="spur-consent__visual" aria-hidden="true">
        <img class="spur-consent__mark spur-consent__cookie"
          src="assets/images/spur-consent-cookie.png?v=2"
          width="72" height="72"
          alt=""
          loading="eager"
          decoding="async" />
      </div>
      <div class="spur-consent__copy">
        <p class="spur-consent__eyebrow">Your privacy on Spur</p>
        <h3 id="spur-consent-title" class="spur-consent__title">Cookies that keep moments personal</h3>
        <p id="spur-consent-desc" class="spur-consent__text">
          Essential cookies keep the site working. Optional ones help us tailor experiences you’ll love.
        </p>
      </div>
      <div class="spur-consent__actions cookies__btn">
        <button type="button" class="spur-consent__btn spur-consent__btn--primary accept_cookie"
          (click)="setCookie('acceptCookies',true,365)">Accept</button>
        <button type="button" class="spur-consent__btn spur-consent__btn--ghost accept_cookie"
          (click)="closeCookies()">Reject</button>
      </div>
    </div>
  </div>

  <vebo-footer *ngIf="currenturl!='ticket-map-web-view'"></vebo-footer>
</div>

<!-- Client-only after hydration: omit from SSR / View Source; mount once so ngx-bootstrap ViewChild works -->
@if (clientModalsReady) {
<!-- agreeTermsModal -->
<div class="modal fade text-left delete-review-modal" id="agreeTermsModal" bsModal #agreeTermsModal="bs-modal"
  tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false"
  [config]="{ backdrop: 'static' }">
  <div class="modal-dialog modal-dialog-centered modal-dialog-width influencerTerms-modal" role="document">
    <div class="modal-content theme-modal ">

      <div class="modal-header reviewHead">
        <h2 class="modal-title">{{influencerTerms?.title}}</h2>
      </div>

      <div class="modal-body">
        <p class="deleteModal-description" [innerHTML]="safeHtml"></p>
      </div>

      <div class="reviewModal-btn">
        <button type="button" class="btn theme-btn px-4" (click)="inflencerAgreeTermsAndConditions()">
          I Agree
        </button>
      </div>

    </div>
  </div>
</div>

<!-- sign up form -->
<div class="modal fade" id="signupModal" bsModal #signupModal="bs-modal" tabindex="-1" role="dialog" aria-hidden="true"
  data-backdrop="static" data-keyboard="false" [config]="{ backdrop: 'static' }">
  <div class="modal-dialog modal-dialog-centered modal-dialog-width" role="document">
    <div class="modal-content signup-modal-content">

      <div class="modal-header signup-modal-header">
        <button type="button" class="signup-close-btn" aria-label="Close" (click)="closePopup()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="modal-body signup-modal-body">
        <div class="modal-head">
          <div class="giftCard-iconBox">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="30"
              height="30" x="0" y="0" viewBox="0 0 468 468" style="enable-background:new 0 0 512 512"
              xml:space="preserve" class="">
              <g>
                <path
                  d="M192.59 137.835c-6.737 0-14.101 2.42-19.184 8.155-6.657 7.51-8.744 29.953-8.497 41.279 11.24.272 32.73-.026 41.436-8.683 9.103-9.053 11.594-24.872 1.914-34.499-4.213-4.19-9.838-6.252-15.669-6.252zM106.795 137.835c6.737 0 14.101 2.42 19.184 8.155 6.657 7.51 8.744 29.953 8.497 41.279-11.24.272-32.731-.026-41.436-8.683-9.103-9.053-11.594-24.872-1.914-34.499 4.213-4.19 9.838-6.252 15.669-6.252z"
                  fill="#FF6B4A" opacity="1" data-original="#000000" class=""></path>
                <path
                  d="M229.471 122.834c17.093 16.996 19.37 43.784 7.659 64.435H468v-75.412C468 88.188 448.777 69 425.065 69H164.699v46.273c21.042-11.873 47.63-9.484 64.772 7.561 9.738 9.683-17.142-17.045 0 0zM101.719 271.619l-21.301-21.163 33.093-33.187H0v138.873C0 379.812 19.223 399 42.935 399h91.709V238.601zM185.7 217.269l32.652 32.913-21.356 21.108-32.297-32.555V399h260.366C448.777 399 468 379.812 468 356.143V217.269zM62.213 187.269c-11.713-20.654-9.432-47.44 7.659-64.435 17.141-17.045 43.729-19.433 64.772-7.561V69H42.935C19.223 69 0 88.188 0 111.857v75.412z"
                  fill="#FF6B4A" opacity="1" data-original="#000000" class=""></path>
              </g>
            </svg>
          </div>
          <h2 class="modal-title signup-modal-title">Save 10% with a Coupon Code</h2>
          <p class="signup-description">
            We will email your code to you.
          </p>
        </div>

        <form [formGroup]="signUpForm" (ngSubmit)="onSubmit()" action="" name="contact_form" id="contact_form"
          method="POST">

          <div class="row mt-4">
            <div class="col-12">
              <div class="form-group">
                <label class="form-labels">Email</label>
                <input type="text" class="form-control" (keyup)="check_email_format($event)"
                  formControlName="user_email" placeholder="Enter email" id="user_email" name="user_email" value="">
                <div *ngIf="submitted && user?.user_email?.errors">
                  <div *ngIf="user?.user_email?.errors?.required" class="text-danger error-msg">Email is required.
                  </div>
                </div>
                <div *ngIf="email_space_error && !user?.user_email?.errors && !invalid_email"
                  class="text-danger error-msg">
                  Email is required.</div>
                <div *ngIf="submitted && !user?.user_email?.errors &&  invalid_email" class="text-danger error-msg">
                  Please enter a valid email.</div>
              </div>
            </div>

            <div class="col-12">
              <div class="custom-div modalPhone-number">
                <label class="form-labels">Phone number</label>
                <ngx-intl-tel-input [cssClass]="'custom custom-number form-control'"
                  [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
                  [searchCountryFlag]="true" [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                  [selectFirstCountry]="true" [maxLength]="14" [separateDialCode]="separateDialCode"
                  [phoneValidation]="true" formControlName="user_phone" (countryChange)="onCountryChange($event)"
                  (input)="formatPhoneNumber($event)">
                </ngx-intl-tel-input>

                <div *ngIf="submitted && user?.user_phone?.errors">
                  <div *ngIf="user?.user_phone?.errors?.required" class="text-danger error-msg">
                    Phone number is required.</div>
                  <div *ngIf="user?.user_phone?.errors?.validatePhoneNumber" class="text-danger error-msg">
                    Please enter valid phone number
                  </div>
                </div>
              </div>
            </div>
          </div>

          <p class="signup-disclaimer">
            * By submitting this form, you consent to receive marketing email from Spur Experiences.
          </p>

          <div class="signup-button-group">
            <button type="submit" class="theme-btn">Unlock Offer</button>
            <button type="button" class="btn signup-cancel-btn" (click)="closePopup()">No thanks</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- coupanModal -->
<div class="modal fade" id="coupanModal" bsModal #coupanModal="bs-modal" tabindex="-1" role="dialog" aria-hidden="true"
  data-backdrop="static" data-keyboard="false" [config]="{ backdrop: 'static' }">
  <div class="modal-dialog modal-dialog-centered coupon-modal-dialog" role="document">
    <div class="modal-content coupon-modal-content">

      <div class="coupon-modal-header">
        <button type="button" class="signup-close-btn" aria-label="Close" (click)="closeThankyouPopup()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <div class="coupon-modal-body">
        <div class="coupon-thank-you">
          <h2>Welcome to Spur – Your Journey Starts Here!</h2>
          <div class="thanksYou-img">
            <img src="../assets/images/thankYou-img.png" alt="promocode">
          </div>
        </div>
        <div class="coupon-message">
          <p>We’re thrilled to have you join us.</p>
          <p>Enhance your experience with exclusive rewards.</p>
        </div>
        <div class="coupon-message">
          <p>
            <ng-container *ngIf="coupanEndDate">Enjoy your exclusive coupon before it expires on {{coupanEndDate}}. </ng-container>
            Don’t miss out—use it today and make the most of your Spur experience!
          </p>
        </div>
        <div class="coupon-code-section">
          <label class="couponCode-text">Click to copy coupon code</label>
          <div class="coupon-code-container" (click)="copyCouponCode()">
            <span class="coupon-code-text">{{coupanData?.coupon_number}}</span>
            <span class="coupon-copy-icon">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M14 6.5H8C7.17157 6.5 6.5 7.17157 6.5 8V18C6.5 18.8284 7.17157 19.5 8 19.5H14C14.8284 19.5 15.5 18.8284 15.5 18V8C15.5 7.17157 14.8284 6.5 14 6.5Z"
                  stroke="black" />
                <path
                  d="M8.5 6C8.5 5.60218 8.65804 5.22064 8.93934 4.93934C9.22064 4.65804 9.60218 4.5 10 4.5H16C16.3978 4.5 16.7794 4.65804 17.0607 4.93934C17.342 5.22064 17.5 5.60218 17.5 6V16C17.5 16.3978 17.342 16.7794 17.0607 17.0607C16.7794 17.342 16.3978 17.5 16 17.5"
                  stroke="black" />
              </svg>
            </span>
          </div>
          <div *ngIf="showCopyMessage" class="copy-message">
            {{copyMessage}}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
}

